var _path, _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessBubblesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 107,
    viewBox: "0 0 160 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.5 29.9688C71.6704 29.9688 64.9941 31.994 59.3155 35.7883C53.6368 39.5827 49.2109 44.9757 46.5973 51.2855C43.9837 57.5952 43.2999 64.5383 44.6323 71.2367C45.9647 77.9351 49.2535 84.088 54.0827 88.9173C58.912 93.7466 65.0649 97.0353 71.7633 98.3677C78.4617 99.7001 85.4048 99.0163 91.7146 96.4027C98.0243 93.7891 103.417 89.3632 107.212 83.6845C111.006 78.0059 113.031 71.3296 113.031 64.5C113.022 55.3447 109.38 46.5672 102.907 40.0934C96.4328 33.6196 87.6553 29.9784 78.5 29.9688ZM93.6606 58.4105L75.0668 77.0043C74.8201 77.2513 74.5272 77.4472 74.2047 77.5809C73.8822 77.7145 73.5366 77.7833 73.1875 77.7833C72.8384 77.7833 72.4928 77.7145 72.1703 77.5809C71.8479 77.4472 71.5549 77.2513 71.3082 77.0043L63.3395 69.0355C62.841 68.5371 62.561 67.8611 62.561 67.1562C62.561 66.4514 62.841 65.7754 63.3395 65.277C63.8379 64.7785 64.5139 64.4985 65.2188 64.4985C65.9236 64.4985 66.5996 64.7785 67.0981 65.277L73.1875 71.3697L89.902 54.652C90.1488 54.4052 90.4417 54.2094 90.7642 54.0758C91.0866 53.9423 91.4322 53.8735 91.7813 53.8735C92.1303 53.8735 92.4759 53.9423 92.7983 54.0758C93.1208 54.2094 93.4138 54.4052 93.6606 54.652C93.9074 54.8987 94.1031 55.1917 94.2367 55.5142C94.3702 55.8366 94.439 56.1822 94.439 56.5312C94.439 56.8803 94.3702 57.2259 94.2367 57.5483C94.1031 57.8708 93.9074 58.1638 93.6606 58.4105Z",
    fill: "#25CD25"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 15,
    r: 7,
    fill: "#95CF48"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 15,
    r: 15,
    fill: "#95CF48",
    fillOpacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 72,
    r: 10,
    fill: "#95CF48",
    fillOpacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 90,
    r: 14,
    fill: "#95CF48",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessBubblesIcon);
export default __webpack_public_path__ + "static/media/SuccessBubblesIcon.19b5430cfdb0db8d609f00bd057ba1e9.svg";
export { ForwardRef as ReactComponent };